function formatarDataHoraEvolucao(dataReferencia) {
  if (!dataReferencia) {
    return "Data nao informada";
  }

  const dataEvolucao = new Date(dataReferencia);
  if (Number.isNaN(dataEvolucao.getTime())) {
    return "Data nao informada";
  }

  return dataEvolucao
    .toLocaleString("pt-BR", {
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
      hour12: false,
    })
    .replace(",", "");
}

function formatarNomeUsuarioEvolucao(evolucao, usuarioPadrao = "Usuario") {
  return (
    evolucao?.usuario?.funcionario?.nome_usu ||
    evolucao?.usuario?.funcionarios?.nome_usu ||
    evolucao?.usuario?.username ||
    (evolucao?.usuarioId ? `Usuario ${evolucao.usuarioId}` : usuarioPadrao)
  );
}

export function formatarMetadadosEvolucao(evolucao, options = {}) {
  const { usuarioPadrao = "Usuario" } = options;

  const dataReferencia =
    evolucao?.criado_em ||
    evolucao?.createdAt ||
    evolucao?.data ||
    evolucao?.alterado_em ||
    evolucao?.updatedAt ||
    evolucao?.criadoEm;

  return {
    usuario: formatarNomeUsuarioEvolucao(evolucao, usuarioPadrao),
    dataHora: formatarDataHoraEvolucao(dataReferencia),
  };
}
